import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-top-articles',
  templateUrl: './top-articles.component.html',
  styleUrls: ['./top-articles.component.css'],
  standalone: false,
})
export class TopArticlesComponent {

    constructor(
    private router: Router,
  ) {}
  
 redirectTag(tag) {
    if (tag.length != 0) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/tag'], { queryParams: { s: encodeURI(tag) } });
      });
    }
  }

  redirectArticle(url) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([url]);
    });
  }
}
